import Axios from 'axios';
import EndPoints from '../EndPoints';

export default class ImagesApi {
	static delete = files => {
		if (Array.isArray(files)) {
			return new Promise((resolve, reject) => {
				Axios({
					method: 'Delete',
					url: EndPoints.Delete,
					data: files
				})
					.then(() => { resolve(); })
					.catch(() => {
						reject(new Error('Clear files failed due to an unexpected error.'));
					});
			});
		}
		return undefined;
	}

	static Recompress = (filePath, compressionMode) => {
		return new Promise((resolve, reject) => {
			Axios({
				method: 'Post',
				url: EndPoints.Recompress,
				data: { file: filePath, ...compressionMode }
			})
				.then(response => { resolve(response); })
				.catch(() => {
					reject(new Error('Unable to compress file due to an error.'));
				});
		});
	}
}



// WEBPACK FOOTER //
// ./src/services/ImagesApiService.js